import { NO_IMAGE_PLACEHOLDER } from "../../common/constants";

const KNOWN_NO_IMAGE_SOURCE_HASHES = [
    "6f37ced36498c7df3a3897a9dbbb3384",
] as const;

const KNOWN_NO_IMAGE_ASSET_IDS = new Set<string>(["768482"]);

export function isSupplierNoImagePlaceholder(
    preview?: string | null,
    assetId?: string | number | null,
): boolean {
    if (assetId != null && KNOWN_NO_IMAGE_ASSET_IDS.has(String(assetId))) {
        return true;
    }
    if (!preview || typeof preview !== "string") {
        return true;
    }
    const normalized = preview.toLowerCase().replace(/\\/g, "/");
    if (normalized.includes(NO_IMAGE_PLACEHOLDER.toLowerCase())) {
        return true;
    }
    return KNOWN_NO_IMAGE_SOURCE_HASHES.some((hash) =>
        normalized.includes(hash),
    );
}
